module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 166);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("react-event-listener");

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_Layer_Layer; });
__webpack_require__.d(__webpack_exports__, "LayerStackContext", function() { return /* reexport */ LayerStack["a" /* LayerStackContext */]; });
__webpack_require__.d(__webpack_exports__, "LayerStackGlobalProvider", function() { return /* reexport */ LayerStack["b" /* LayerStackGlobalProvider */]; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(60);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react-event-listener"
var external_react_event_listener_ = __webpack_require__(15);
var external_react_event_listener_default = /*#__PURE__*/__webpack_require__.n(external_react_event_listener_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "@splunk/ui-utils/keyboard"
var keyboard_ = __webpack_require__(9);

// EXTERNAL MODULE: ./src/Layer/LayerStack.tsx
var LayerStack = __webpack_require__(68);

// CONCATENATED MODULE: ./src/Layer/Layer.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/** @public */

var possibleCloseReasons = ['clickAway', 'escapeKey'];
var propTypes = {
  children: external_prop_types_default.a.node,
  closeReasons: external_prop_types_default.a.arrayOf(external_prop_types_default.a.oneOf(possibleCloseReasons)),
  onRequestClose: external_prop_types_default.a.func,
  open: external_prop_types_default.a.bool
};
var defaultProps = {
  closeReasons: possibleCloseReasons,
  open: false
};

var Layer_Layer = /*#__PURE__*/function (_Component) {
  _inherits(Layer, _Component);

  var _super = _createSuper(Layer);

  // @docs-props-type LayerPropsBase
  // eslint-disable-next-line react/sort-comp
  // LayerStackContext (an array) keeps track of the current instances of Layer. This is
  // used by Layer#handleKeyDown to determine if the escapeKey event should be handled by
  // the current instance. Only the topmost Layer instance should honor the escapeKey.
  // TODO: enable once this is sorted out within the babel/ts ecosystem
  // declare context: React.ContextType<typeof LayerStackContext>;
  function Layer(props) {
    var _this;

    _classCallCheck(this, Layer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "layerClickEvent", null);

    _defineProperty(_assertThisInitialized(_this), "handleClickOnLayer", function (_ref) {
      var nativeEvent = _ref.nativeEvent;
      _this.layerClickEvent = nativeEvent;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOnWindow", function (event) {
      var _this$props$onRequest, _this$props;

      // clicks inside the layer should not be considered clickAways
      if (!_this.props.open || !Object(external_lodash_["includes"])(_this.props.closeReasons, 'clickAway') || _this.layerClickEvent === event) {
        return;
      }

      (_this$props$onRequest = (_this$props = _this.props).onRequestClose) === null || _this$props$onRequest === void 0 ? void 0 : _this$props$onRequest.call(_this$props, {
        event: event,
        reason: 'clickAway'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDownOnWindow", function (event) {
      if (_this.props.open && Object(keyboard_["keycode"])(event) === 'esc' && Object(external_lodash_["last"])(_this.getLayerStack()) === _assertThisInitialized(_this) && Object(external_lodash_["includes"])(_this.props.closeReasons, 'escapeKey')) {
        var _this$props$onRequest2, _this$props2;

        (_this$props$onRequest2 = (_this$props2 = _this.props).onRequestClose) === null || _this$props$onRequest2 === void 0 ? void 0 : _this$props$onRequest2.call(_this$props2, {
          event: event,
          reason: 'escapeKey'
        });
      }
    });

    if (!Layer.layerContainer) {
      Layer.layerContainer = document.createElement('div');
      Layer.layerContainer.setAttribute('data-test', 'layer-container');
      document.body.appendChild(Layer.layerContainer);
    }

    return _this;
  }

  _createClass(Layer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.getLayerStack().push(this);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.getLayerStack().push(this);
      } else if (prevProps.open && !this.props.open) {
        Object(external_lodash_["pull"])(this.getLayerStack(), this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object(external_lodash_["pull"])(this.getLayerStack(), this);
    }
  }, {
    key: "getLayerStack",
    value: function getLayerStack() {
      return this.context;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          open = _this$props3.open;

      if (open) {
        var layerPortal = /*#__PURE__*/Object(external_react_dom_["createPortal"])( /*#__PURE__*/external_react_default.a.createElement("div", {
          // eslint-disable-line jsx-a11y/no-static-element-interactions
          "data-test": "layer",
          onMouseDown: this.handleClickOnLayer,
          onTouchStart: this.handleClickOnLayer
        }, children), Layer.layerContainer // eslint-disable-line @typescript-eslint/no-non-null-assertion
        );
        return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(external_react_event_listener_default.a, {
          key: "eventListener",
          target: "window",
          onKeyDown: this.handleKeyDownOnWindow,
          onMouseDown: this.handleClickOnWindow,
          onTouchStart: this.handleClickOnWindow
        }), layerPortal);
      }

      return null;
    }
  }]);

  return Layer;
}(external_react_["Component"]);

_defineProperty(Layer_Layer, "layerContainer", null);

_defineProperty(Layer_Layer, "possibleCloseReasons", possibleCloseReasons);

_defineProperty(Layer_Layer, "propTypes", propTypes);

_defineProperty(Layer_Layer, "defaultProps", defaultProps);

_defineProperty(Layer_Layer, "contextType", LayerStack["a" /* LayerStackContext */]);

/* harmony default export */ var src_Layer_Layer = (Layer_Layer);
// CONCATENATED MODULE: ./src/Layer/index.ts



/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerStackContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LayerStackGlobalProvider; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



/**
 * `LayerStackContext` is used to manage the array that `Layer` (and components that
 * depend on it, such as `Modal`) uses to determine the order of open layers.
 * @public
 */
var LayerStackContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext([]);
var propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  scope: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object
};
/* global global */

/**
 * A `LayerStackContext` provider that stores a shared layer stack using a global variable.
 * Applications should only use this provider if there's a known need to support multiple
 * instances of this library on the same page.
 */

function LayerStackGlobalProvider(_ref) {
  var children = _ref.children,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '__splunkui_layer_instances__' : _ref$name,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? typeof window !== 'undefined' ? window : global : _ref$scope;

  if (!scope[name]) {
    scope[name] = []; // eslint-disable-line no-param-reassign
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(LayerStackContext.Provider, {
    value: scope[name]
  }, children);
}

LayerStackGlobalProvider.propTypes = propTypes;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)))

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/keyboard");

/***/ })

/******/ });